export default __webpack_public_path__ + "static/media/ketoparties@3x.75de5a66.jpg";